module.exports = __webpack_public_path__ + "img/well-being-impact.07d031ab.svg";